import envService from '@/services/env.service';
import axios from 'axios';

const BASE_URL = envService.getApiBaseUrl() + '/sms/statistics';

export default {
  async getCostLimitQuotasByWebId(webId) {
    return axios.get(`${BASE_URL}/${webId}/costlimit`);
  },
};
